
define('app/board/views/soundView',[
	'jquery',
	'underscore',
	'backbone',
	//Shims
	'jquery.ion.sound'
], function($, _, BackboneDraftOptionsModel, TimerModel){
	var SoundView = Backbone.View.extend({
		initialize: function(options) {
			this.lgInstanceModel = options.leagueInstance;
			this.draftStatusModel = options.draftStatusModel;
			
			this.soundEnabled = false;
			this.curDraftingTeamID = this.draftStatusModel.get('draftingTeamId');
			this.curPosRound = this.draftStatusModel.get('posInRound');
			this.lastTeamSong = "";
			
			if(this.lgInstanceModel.get('id') == 245836){
				$.ionSound({
				    sounds: [
				        {name: "countdown"},
				        {name: "playerPicked"},
				        {name: "timerExp"},
				        {name: "timerWarning"},
				        {name: "ballers"}
				    ],
				    path: "https://drj9w7fd3b8pf.cloudfront.net/draft/sounds/",
				    multiplay: true,
				    volume: 0.5
				});
			} else if(this.lgInstanceModel.get('id') == 140889){
				$.ionSound({
				    sounds: [
				        {name: "countdown"},
				        {name: "playerPicked"},
				        {name: "timerExp"},
				        {name: "timerWarning"},
				        {name: "fireball"}
				    ],
				    path: "https://drj9w7fd3b8pf.cloudfront.net/draft/sounds/",
				    multiplay: true,
				    volume: 0.5
				});
			} else if(this.lgInstanceModel.get('id') == 276817){
				$.ionSound({
				    sounds: [
				        {name: "countdown", volume: .5},
				        {name: "playerPicked", volume: .5},
				        {name: "timerExp", volume: .5},
				        {name: "timerWarning", volume: .5},
				        {name: "oatdogg_scott"},
				        {name: "oatdogg_walsh"},
				        {name: "oatdogg_rysan"},
						{name: "oatdogg_rysan_wrap"},
				        {name: "oatdogg_luzim"},
						//{name: "oatdogg_luzim_wrap"},
				        {name: "oatdogg_oates"},
						//{name: "oatdogg_oates_wrap"},
				        {name: "oatdogg_lerch"},
				        {name: "oatdogg_kris"},
						//{name: "oatdogg_kris_wrap"},
				        {name: "oatdogg_judd"},
				        {name: "oatdogg_billy"},
						{name: "oatdogg_billy_wrap"},
				        {name: "oatdogg_evan"},
				        {name: "oatdogg_burns"},
				        {name: "oatdogg_austin"},

				    ],
				    path: "https://drj9w7fd3b8pf.cloudfront.net/draft/sounds/",
				    multiplay: true,
				    preload: true,
				    volume: 0.5
				});
				//this.draftStatusModel.bind("change:draftingTeamId", this.playTeamSong, this);
				//this.draftStatusModel.bind("change:round", this.playTeamSong, this);
				this.draftStatusModel.bind("change:posInRound", this.playTeamSong, this);
			} else if(this.lgInstanceModel.get('id') == 277998){
				$.ionSound({
				    sounds: [
				        {name: "countdown"},
				        {name: "playerPicked"},
				        {name: "timerExp"},
				        {name: "timerWarning"},
				        {name: "bretwisch_draft"}
				    ],
				    path: "https://drj9w7fd3b8pf.cloudfront.net/draft/sounds/",
				    multiplay: true,
				    volume: 0.5
				});
			} else {
				$.ionSound({
				    sounds: [
				        {name: "countdown"},
				        {name: "playerPicked"},
				        {name: "timerExp"},
				        {name: "timerWarning"}
				    ],
				    path: "https://drj9w7fd3b8pf.cloudfront.net/draft/sounds/",
				    multiplay: true,
				    volume: 0.5
				});
			}
			
			_.bindAll(this, 'playCountdown');
			_.bindAll(this, 'playTimerExp');
			_.bindAll(this, 'playTimerWarning');
			_.bindAll(this, 'playPickMade');
			_.bindAll(this, 'enableSound');
			_.bindAll(this, 'playTeamSong');
			_.bindAll(this, 'timerStart');
			_.bindAll(this, 'timerStop');
			
			$(document).on('draftApp:playerPicked', this.playPickMade);
			$(document).on('draftApp:loadingComplete', this.enableSound);
			
			
		},
		
		render: function () {
			
			return this;
		},
		
		enableSound: function() {
			this.soundEnabled = true;
		},
		
		//Sounds provided by http://www.freesfx.co.uk
		
		playCountdown: function() {
			if(this.soundEnabled){
				if(this.lgInstanceModel.get('id') == 276817){
					$.ionSound.play("countdown");
				} else {
					$.ionSound.play("countdown");
				}				
			}
		},
		
		playTimerExp: function() {
			if(this.soundEnabled){
				if(this.lgInstanceModel.get('id') == 276817){
					if(this.lastTeamSong != ""){	
						try{
							$.ionSound.stop(this.lastTeamSong);
						} catch(err){
							
						}
						
					}
					
					$.ionSound.play("timerExp");
				} else {
					$.ionSound.play("timerExp");
				}
			}
		},
		
		playTimerWarning: function() {
			if(this.soundEnabled){
				if(this.lgInstanceModel.get('id') == 276817){
					$.ionSound.play("timerWarning");
				} else {
					$.ionSound.play("timerWarning");
				}
			}
		},
		
		playPickMade: function(event, playerId) {
			if(this.soundEnabled){
				if(this.lgInstanceModel.get('id') == 276817){
					$.ionSound.play("playerPicked");
				} else if(this.lgInstanceModel.get('id') == 245836){
					$.ionSound.play("ballers");
				} else if(this.lgInstanceModel.get('id') == 169493 && playerId){
					switch (playerId) {
					//Ronald Acuna Jr 17996
					case 17996:
					//Starling Marte
					case 4858:
					//Charlie Blackmon
					case 5206:
					//Cavan Biggio
					case 17537:
					//Adam Eaton
					case 4498:
					//Nelson Cruz
					case 5123:
					//Rhys Hoskins
					case 14768:
					//Giancarlo Stanton
					case 4326:
					//Max Muncy
					case 9448:
					//Kenley Jansen
					case 5228:
					//Dinelson Lamet
					case 14401:
					//Chris Sale
					case 4476:
						$.ionSound.play("fireball");
						break;
					default:
						$.ionSound.play("playerPicked");
						break;
					}
				} else if(this.lgInstanceModel.get('id') == 277998 && playerId){
					switch (playerId) {			
					//62,24,33,55,59,87,9,83,90,40,14,31,64,94,91,76
					//9,14,24,31,33,40,55,59,62,64,76,83,87,90,91,94
					
					//9 Josh Jacob GB RB - 
					case 23068:
					//14 Kyren Williams LA RB - 
					case 33149:
					//24 James Cook RB Buf - 
					case 33122:
					//31 Tua Tagovailoa QB Mia - 
					case 26454:
					//33 Chuba Hubbard Rb Car - 
					case 30086:
					//40 DK Metcalf WR Pit - 
					case 23005:
					//55 Aaron Rodgers QB Pit - 
					case 1658:
					//59 Travis Hunter WR Jac - 
					case 45830:
					//62 Anthony Richardson QB Ind - 
					case 37166:
					//64 Isiah Pacheco RB KC - 
					case 33135:
					//76 Dallas Goedert TE PHI - 
					case 18639:
					//83 Michael Pittman WR Ind - 
					case 26585:
					//87 Jonnu Smith TE Pit - 
					case 13869:
					//90 Hunter Henry TE NE - 
					case 11710:
					//91 Jayden Higgins WR Hou - 
					case 45837:
					//94 Isaac Guerendo RB SF - 
					case 41712:
					// Team coach for testing (GB Coach)
					case 3019:
						$.ionSound.play("bretwisch_draft");
						break;
					default:
						$.ionSound.play("playerPicked");
						break;
					}
				} else {
					$.ionSound.play("playerPicked");
				}
				
				
			}
		},
		
		playTeamSong: function() {
			playSong = false;
			wraparound = false;
			/*if(this.curDraftingTeamID != this.draftStatusModel.get('draftingTeamId')){
				playSong = true;
				this.curDraftingTeamID = this.draftStatusModel.get('draftingTeamId');
			}*/ 
			
			if(this.curPosRound != this.draftStatusModel.get('posInRound')){
				if(this.curDraftingTeamID == this.draftStatusModel.get('draftingTeamId')){
					wraparound = true;
				}
				
				playSong = true;
				this.curPosRound = this.draftStatusModel.get('posInRound');
				this.curDraftingTeamID = this.draftStatusModel.get('draftingTeamId');
			}
			
			
			if(this.soundEnabled){				
				if(playSong && this.lgInstanceModel.get('id') == 276817){
					if(this.lastTeamSong != ""){	
						try{
							$.ionSound.stop(this.lastTeamSong);
						} catch(err){
							
						}
						
					}
					
					switch (this.curDraftingTeamID) {
					case 3007917:
						$.ionSound.play("oatdogg_austin");
						this.lastTeamSong = "oatdogg_austin";
						break;
					case 3007914:
						if(wraparound) {
							$.ionSound.play("oatdogg_rysan_wrap");
							this.lastTeamSong = "oatdogg_rysan_wrap";
						} else {
							$.ionSound.play("oatdogg_rysan");
							this.lastTeamSong = "oatdogg_rysan";
						}
						
						break;
					case 3007922:
						//if(wraparound) {
						//	$.ionSound.play("oatdogg_kris_wrap");
						//	this.lastTeamSong = "oatdogg_kris_wrap";
						//} else {
							$.ionSound.play("oatdogg_kris");
							this.lastTeamSong = "oatdogg_kris";	
						//}
						
						break;
					case 3007919:
						//if(wraparound) {
						//	$.ionSound.play("oatdogg_oates_wrap");
						//	this.lastTeamSong = "oatdogg_oates_wrap";
						//} else {
							$.ionSound.play("oatdogg_oates");
							this.lastTeamSong = "oatdogg_oates";
						//}
						
						break;
					case 3007921:
						$.ionSound.play("oatdogg_lerch");
						this.lastTeamSong = "oatdogg_lerch";
						break;
					case 3007916:
						$.ionSound.play("oatdogg_evan");
						this.lastTeamSong = "oatdogg_evan";
						break;
					case 3007920:
						$.ionSound.play("oatdogg_scott");
						this.lastTeamSong = "oatdogg_scott";
						break;
					case 3007924:
						$.ionSound.play("oatdogg_judd");
						this.lastTeamSong = "oatdogg_judd";
						break;
					case 3007918:
						//if(wraparound) {
						//	$.ionSound.play("oatdogg_luzim_wrap");
						//	this.lastTeamSong = "oatdogg_luzim_wrap";
						//} else {
							$.ionSound.play("oatdogg_luzim");
							this.lastTeamSong = "oatdogg_luzim";
						//}
						
						break;
					case 3007915:
						$.ionSound.play("oatdogg_burns");
						this.lastTeamSong = "oatdogg_burns";
						break;
					case 3007923:
						$.ionSound.play("oatdogg_walsh");
						this.lastTeamSong = "oatdogg_walsh";
						break;
					case 3007925:
						if(wraparound) {
							$.ionSound.play("oatdogg_billy_wrap");
							this.lastTeamSong = "oatdogg_billy_wrap";
						} else {
							$.ionSound.play("oatdogg_billy");
							this.lastTeamSong = "oatdogg_billy";
						}
						
						
						break;
					default:
						break;
					}					
				}
			}
		},
		
		timerStop: function() {
			if(this.soundEnabled){				
				if(this.lgInstanceModel.get('id') == 276817){
					if(this.lastTeamSong != "" && this.draftStatusModel.get('round') == 1 && this.draftStatusModel.get('posInRound') == 1){	
						try{
							this.lastTeamSong = "";
							$.ionSound.stop(this.lastTeamSong);
						} catch(err){
							
						}
						
					}
				}
			}
		},
		
		timerStart: function() {
			if(this.soundEnabled){				
				if(this.lgInstanceModel.get('id') == 276817){
					if(this.lastTeamSong == "" && this.draftStatusModel.get('round') == 1 && this.draftStatusModel.get('posInRound') == 1){
						this.lastTeamSong = "oatdogg_rysan";	
						$.ionSound.play("oatdogg_rysan");
					}
				}
			}
		},
	});
	
	return SoundView;  
});